import { useEffect, useState } from "react";
import { apiGET } from "../../../apis/handler";

// Sample call recordings for the Call Audit training/assignment pages, fetched from
// an authenticated backend endpoint instead of being bundled as static data in the
// frontend (that used to ship real borrower PII + S3 recording URLs to anyone who
// opened the public JS bundle, logged in or not).
let cachedData = null;
let inFlightRequest = null;

export function useCallAuditTrainingData() {
  const [data, setData] = useState(cachedData || []);
  const [loading, setLoading] = useState(!cachedData);

  useEffect(() => {
    if (cachedData) {
      setData(cachedData);
      setLoading(false);
      return;
    }

    let mounted = true;
    if (!inFlightRequest) {
      inFlightRequest = apiGET("/call/api/call_audit_training_data/");
    }

    inFlightRequest.then((res) => {
      if (res.success) {
        cachedData = res.data?.data || [];
        if (mounted) setData(cachedData);
      }
      if (mounted) setLoading(false);
    });

    return () => {
      mounted = false;
    };
  }, []);

  return { teleCollectioAsgmt: data, loading };
}
